import { Availability, ShopsAvailable } from '@availability/const';
import { StateUtils } from '@spartacus/core';

export const AVAILABILITY_FEATURE = 'Availability';
export const AVAILABILITY = '[Availability] Availability';
export const SHOPS_AVAILABLE = '[Availability] Shops available';

export interface AvailabilityState {
  availability: StateUtils.EntityLoaderState<Availability>;
  shopsAvailable: StateUtils.EntityLoaderState<ShopsAvailable>;
}

export interface StateWithAvailability {
  [AVAILABILITY_FEATURE]: AvailabilityState;
}
